module.exports = __webpack_public_path__ + "img/website-bg.6865c214.png";